/* ================================
  HTML Update Utility
================================ */
class HTMLUpdateUtility {
  static setInnerHTML(element, html) {
    element.innerHTML = html;

    const scripts = element.querySelectorAll('script');
    scripts.forEach(oldScript => {
      const newScript = document.createElement('script');
      [...oldScript.attributes].forEach(attr =>
        newScript.setAttribute(attr.name, attr.value)
      );
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }
}

/* ================================
  QUICK VIEW – INVENTORY CHECK
================================ */
async function qvCheckInventory(form, variantId, requestedQty) {
  const json = form.querySelector('#product-variants-json');
  if (!json) return { allowed: true };

  const variants = JSON.parse(json.textContent);
  const variant = variants.find(v => v.id == variantId);
  const maxQty = variant?.inventory_quantity ?? Infinity;

  let alreadyInCart = 0;

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    cart.items.forEach(item => {
      if (item.variant_id == variantId) {
        alreadyInCart = item.quantity;
      }
    });
  } catch (e) {
    console.error('Cart fetch failed', e);
    return { allowed: true };
  }

  if (alreadyInCart + requestedQty > maxQty) {
    return {
      allowed: false,
      message: `You already have ${alreadyInCart} in cart. Only ${Math.max(
        0,
        maxQty - alreadyInCart
      )} more available.`
    };
  }

  return { allowed: true };
}

/* ================================
  QUICK VIEW SWIPER
================================ */
function initQuickViewSwiper(scope) {
  const mainEl = scope.querySelector('.main-slider');
  const thumbEl = scope.querySelector('.thumbnail-slider');
  if (!mainEl || !thumbEl || typeof Swiper === 'undefined') return;

  if (mainEl.swiper) mainEl.swiper.destroy(true, true);
  if (thumbEl.swiper) thumbEl.swiper.destroy(true, true);

  const thumbSlider = new Swiper('.quick-view-image .thumbnail-slider', {
    spaceBetween: 10,
    slidesPerView: 'auto',
    autoHeight: true,
    mousewheel: true
  });

  new Swiper('.quick-view-image .main-slider', {
    spaceBetween: 10,
    slidesPerView: 'auto',
    autoHeight: true,
    thumbs: { swiper: thumbSlider }
  });
}

/* ================================
  QUICK VIEW INIT
================================ */
function initQuickViewScripts(scope = document) {
  const modal = document.getElementById('quick-view-modal');
  const modalContent = document.getElementById('quick-view-data');
  if (!modal || !modalContent) return;

  function showModal() {
    document.body.classList.add('overflow-hidden');
    modal.setAttribute('open', '');
    modal.style.display = 'flex';
  }

  function hideModal() {
    document.body.classList.remove('overflow-hidden');
    modal.removeAttribute('open');
    modal.style.display = 'none';
    modalContent.innerHTML = '';
  }

  function preprocessHTML(productEl, sectionId) {
    const newId = `quickview-${sectionId}`;
    productEl.innerHTML = productEl.innerHTML.replaceAll(sectionId, newId);
    productEl.setAttribute('data-update-url', 'false');
    productEl.querySelector('pickup-availability')?.remove();
    productEl.querySelector('product-modal')?.remove();
    productEl.querySelectorAll('modal-dialog')?.forEach(m => m.remove());
  }

  scope.querySelectorAll('.quick-view-btn').forEach(btn => {
    if (btn.dataset.qvInit) return;
    btn.dataset.qvInit = 'true';

    btn.addEventListener('click', async () => {
      const url =
        btn.dataset.productUrl ||
        `/products/${btn.dataset.productHandle}`;

      try {
        const res = await fetch(url);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const productDetails = doc.querySelector('.product-details');
        if (!productDetails) return;

        const clone = productDetails.cloneNode(true);
        const sectionId =
          clone.dataset.section ||
          doc.querySelector('[id^="MainProduct"]')?.id ||
          'quickview';

        preprocessHTML(clone, sectionId);

        const gallery = doc.querySelector('.product-gallery')?.outerHTML || '';

        HTMLUpdateUtility.setInnerHTML(
          modalContent,
          `
          <div class="quick-view-wrapper">
            <button class="quick-view-close" type="button">×</button>
            <div class="quick-view-content">
              <div class="quick-view-image">${gallery}</div>
              <div class="quick-view-details">${clone.innerHTML}</div>
            </div>
          </div>
        `
        );
        let qsmzSettingsText = null;

        doc.querySelectorAll('script').forEach(script => {
          if (script.textContent.includes('window.qsmzsettings')) {
            qsmzSettingsText = script.textContent;
            console.log('qsmzSettingsText: ',qsmzSettingsText);
          }
           console.log('script: ',script);
        });

        if (qsmzSettingsText) {
          const match = qsmzSettingsText.match(/window\.qsmzsettingsblock\s*=\s*({[\s\S]*?})/);
          console.log('match',match);
          if (match && match[1]) {
            try {
              const parsed = new Function("return " + match[1])();

              // 🔥 Important
              window.qsmzsettings = parsed;
              qsmzsettings = parsed;

            } catch (e) {
              console.error("QSMZ parse error", e);
            }
          }
        }

        setTimeout(() => {
          loadQstomizer();
        }, 300);

/* ================================
  SOLD OUT BADGE – QUICK VIEW
  (Same logic as ProductForm)
================================ */
(function initQuickViewSoldOut() {
  const qvRoot = modalContent; // 👈 IMPORTANT (scope)
  const soldOutBadge = qvRoot.querySelector('.sold_out_badge_pdp');
  const variantsJson = qvRoot.querySelector('#product-variants-json');

  if (!soldOutBadge || !variantsJson) return;

  const variants = JSON.parse(variantsJson.textContent);

  // 🔹 ALWAYS hide on quick view open
  soldOutBadge.style.display = 'none';

  function updateSoldOutBadgeQV() {
    const variantInput =
      qvRoot.querySelector('input[name="id"]:checked') ||
      qvRoot.querySelector('input[name="id"]');

    if (!variantInput) {
      soldOutBadge.style.display = 'none';
      return;
    }

    const currentVariant = variants.find(
      v => String(v.id) === String(variantInput.value)
    );

    if (!currentVariant) {
      soldOutBadge.style.display = 'none';
      return;
    }

    // ✅ EXACT PDP LOGIC
    if (!currentVariant.available) {
      soldOutBadge.style.display = 'inline-flex';
    } else {
      soldOutBadge.style.display = 'none';
    }
  }

  // 🔹 Run once after render
  setTimeout(updateSoldOutBadgeQV, 0);

  // 🔹 Run on variant change (radio / dropdown)
  qvRoot.addEventListener('change', e => {
    if (
      e.target.matches('input[name="id"]') ||
      e.target.matches('select[name="id"]') ||
      e.target.matches('[name^="option-"]')
    ) {
      updateSoldOutBadgeQV();
    }
  });
})();

        const desc = modalContent.querySelector(
          '.pdp-description-wrapper .pdp-description'
        );

        if (desc) {
          modalContent.querySelectorAll('.qv-read-more').forEach(b => b.remove());

          desc.classList.add('qv-clamped');

          requestAnimationFrame(() => {
            if (desc.scrollHeight <= desc.clientHeight + 2) {
              desc.classList.remove('qv-clamped');
              return;
            }

            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'qv-read-more';
            btn.textContent = 'Read more';

            btn.addEventListener('click', () => {
              const clamped = desc.classList.toggle('qv-clamped');
              btn.textContent = clamped ? 'Read more' : 'Read less';
            });

            desc.after(btn);
          });
        }


        initQuickViewSwiper(modalContent);
        showModal();

        modalContent
          .querySelector('.quick-view-close')
          ?.addEventListener('click', hideModal);

        /* ================================
          ADD TO CART – INVENTORY SAFE
        ================================ */
        // const form = modalContent.querySelector('form[action*="/cart/add"]');
        // if (form && !form.dataset.qvInvInit) {
        //   form.dataset.qvInvInit = 'true';

        //   form.addEventListener('submit', async e => {
        //     e.preventDefault();

        //     const qtyInput = form.querySelector('[name="quantity"]');
        //     const variantInput = form.querySelector('[name="id"]');
        //     const msgBox = form.querySelector('.cart-qty-message');
        //     const msgText = msgBox?.querySelector('.text');

        //     const requestedQty = parseInt(qtyInput?.value) || 1;
        //     const variantId = variantInput?.value;

        //     const check = await qvCheckInventory(
        //       form,
        //       variantId,
        //       requestedQty
        //     );

        //     if (!check.allowed) {
        //       if (msgBox && msgText) {
        //         msgText.textContent = check.message;
        //         msgBox.style.display = 'flex';
        //         clearTimeout(msgBox.hideTimer);
        //         msgBox.hideTimer = setTimeout(() => {
        //           msgBox.style.display = 'none';
        //         }, 3000);
        //       }
        //       return;
        //     }

        //     fetch('/cart/add.js', {
        //       method: 'POST',
        //       body: new FormData(form),
        //       headers: { 'X-Requested-With': 'XMLHttpRequest' }
        //     })
        //       .then(r => r.json())
        //       .then(item => {
        //         document.body.dispatchEvent(
        //           new CustomEvent('ajaxProduct:added', { detail: { item } })
        //         );
        //       });
        //   });
        // }
      } catch (e) {
        console.error(e);
      }
    });
  });
}

/* ================================
  QUANTITY + / −
================================ */
// document.addEventListener('click', function (e) {
//   const modal = document.getElementById('quick-view-modal');
//   if (!modal || !modal.hasAttribute('open')) return;

//   const btn = e.target.closest('.quantity-increase, .quantity-decrease');
//   if (!btn) return;

//   const wrapper = btn.closest('.side-cart-item__quantity');
//   const input = wrapper?.querySelector('input[type="number"]');
//   if (!input) return;

//   e.preventDefault();

//   let value = parseInt(input.value) || 1;
//   if (btn.classList.contains('quantity-increase')) value++;
//   if (btn.classList.contains('quantity-decrease')) value = Math.max(1, value - 1);

//   input.value = value;
//   input.dispatchEvent(new Event('change', { bubbles: true }));
// });
document.addEventListener('click', function (e) {
  const modal = document.getElementById('quick-view-modal');
  const modalContent = document.getElementById('quick-view-data');

  if (!modal || !modal.hasAttribute('open')) return;
  if (!modalContent || !modalContent.contains(e.target)) return;

  const btn = e.target.closest('.quantity-increase, .quantity-decrease');
  if (!btn) return;

  e.preventDefault();
  e.stopImmediatePropagation(); // 🔥 VERY IMPORTANT

  const wrapper = btn.closest('.side-cart-item__quantity');
  const input = wrapper?.querySelector('input[type="number"]');
  if (!input) return;

  let value = parseInt(input.value, 10) || 1;

  if (btn.classList.contains('quantity-increase')) value += 1;
  if (btn.classList.contains('quantity-decrease')) value = Math.max(1, value - 1);

  input.value = value;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* ================================
  INIT
================================ */
document.addEventListener('DOMContentLoaded', () => {
  initQuickViewScripts(document);
});

document.addEventListener('shopify:section:load', () => {
  initQuickViewScripts(document);
});
